export default {"src":"/_next/static/media/phone.4be49c6b.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};